import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchPermissionsById = createAsyncThunk('getPermissions/fetchPermissionsById',
  async (userId, { rejectWithValue }) => {
    try {
      const url = `${api.permissions.getLoggedIn}/${userId}`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getPermissionListByIdSlice = createSlice({
  name: 'PermissionsById',
  initialState: {
    permissionsById: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchPermissionsById.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchPermissionsById.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.permissionsById = action.payload;
        })
      .addCase(fetchPermissionsById.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getPermissionListByIdSlice.reducer;